<div class="top-exchanges-card">
  <div class="card-header">
    <h3 class="card-title">Top Exchanges</h3>
  </div>
  <div class="card-content">
    <div class="table-header">
      <div class="header-cell">Exchange</div>
      <div class="header-cell text-right">Price</div>
      <!-- <div class="header-cell text-right">Volume</div>
      <div class="header-cell text-right">Change</div> -->
    </div>
    <div class="exchange-list">
      <div *ngFor="let exchange of exchangePrices; let i = index;" class="exchange-row">
        <div class="cell">
          <div class="exchange-info">
            <div class="rank-badge">{{ i + 1 }}</div>
            <span class="exchange-name">{{ exchange.name }}</span>
          </div>
        </div>
        <div class="exchange-name text-right">{{ exchange.price }}</div>
        <!-- <div class="cell text-right">{{ exchange.volume }}</div>
        <div
          class="cell text-right font-medium"
          [ngClass]="{
            positive: exchange.isPositive,
            negative: !exchange.isPositive
          }"
        >
          {{ exchange.change }}
        </div> -->
      </div>
    </div>
  </div>
</div>
